import moment from 'moment';
import { FC, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { UnicaPayInfo } from '../../types';

export const MinaraHub: FC<any> = ({ data }: { data: UnicaPayInfo }) => {
  return (
    <div
      className='d-flex mb-3 mt-2 border border-primary'
      style={{ position: 'relative' }}>
      <img width={200} style={{ marginRight: 20 }} src={data.imageUrl} />
      <div className='w-100 align-items-center'>
        <div className='d-flex align-items-center'>
          <Col lg={3} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>ORDER ID</h5>
            <h4 className='fs-15 mb-0'>{data.id}</h4>
          </Col>
          <Col lg={3} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>
              DATE OF PURCHASE
            </h5>
            <h4 className='fs-15 mb-0'>
              {moment(data?.datePaid).format('DD MMM YYYY')}
            </h4>
          </Col>
        </div>
      </div>
    </div>
  );
};
